
  export default {
    layout: 'error-page',
    data() {
      return {
        loading: true,
        changepassToken: null,
        form: {
          password: null,
          confirmPassword: null,
        },
        //Form error variables
        errors: {
          formError: null,
          formErrMsg: "Opps! Something went wrong, please try again."
        },
        // Form submit variables
        submit: {
          loading: false,
          success: false,
          errored: false
        }
      }
    },

    created() {
      this.changepassToken = this.$route.query.token ? this.$route.query.token : this.$router.push({
        path: '/login'
      });
    },

    // Check login token
    mounted() {
      this.loading = false;
    },
    methods: {
      // To clear the submit error message
      clearFormErrMsg() {
        this.errors.formError = null;
        this.submit.success = false
        this.submit.errored = false
      },
      // Validate and Submit form data to LOGIN
      sendMessage() {
        // Clear all submit errors before API call
        this.errors.formError = null;
        this.submit.success = false
        this.submit.errored = false
        // Validate all fields for making the API call, throw error and not call API if validation errors are present
        this.$refs.resetPasswordForm.validate().then((success) => {
          if (!success) {
            // run your error code here
            this.errors.formError = "One or more incorrect fields present, please fix.";
          } else {
            // If Valid form
            // Create url encoded formData instance to pass the data to the API
            var formData = new URLSearchParams();
            formData.append("newPassword", this.form.password.trim());
            // Add header for the API
            const headers = {
              'Content-Type': 'application/x-www-form-urlencoded',
              Authorization: 'bearer ' + this.changepassToken
            }
            this.submit.loading = true;
            // AXIOS api call to add SIGNIN api
            this.$axios
              .post("/api/users/resetPassword", formData, {
                headers: headers
              })
              .then(response => {
                this.submit.success = true
                this.submit.errored = false
                let value = this.getCryptKey(response.data);
                  localStorage.setItem("authToken", "bearer " + value.token);
                  this.$store.commit('login', value.token);
                  this.myProfile(value.token);
              })
              .catch(error => {
                if (error.response)
                  this.errors.formErrMsg = "Something went wrong, please try again."
                this.submit.success = false
                this.submit.errored = true
              })
              .finally(() => {
                this.submit.loading = false
              });
          }
        });
      },
      myProfile(token) {
        // Add header for the API
        const headers = {
          'Content-Type': 'application/x-www-form-urlencoded',
          'Authorization': "bearer " + token,
        }
        // AXIOS api call to add SIGNIN api
        this.$axios
          .get("/api/users/me/", {
            headers: headers
          })
          .then(response => {
            // New flow
            let value = this.getCryptKey(response.data);
            localStorage.setItem("profile", JSON.stringify(value));
            this.$store.commit('profile', value.username);
            this.$router.push({
              path: '/'
            })
          })
          .catch(error => {});
      },
    }
  }

